export default "__VITE_ASSET__J$s0Wuiy__"